import React from "react";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import "./style.scss";

interface ButtonCancelProps {
  title: string;
  onClick: (value: string) => void;
}

export const ButtonCancel = ({ title, onClick }: ButtonCancelProps) => {
  return (
    <SecondaryButton className="buttonCancel" onClick={onClick}>
      {title}
    </SecondaryButton>
  );
};
